<template>
  <v-row class="align-center justify-center" style="height: 100%;">
    <v-col class="text-center">
      
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: 'Dashboard',

  data: () => ({
    
  }),
  methods: {
    
  }
};
</script>
